import { useEditNetworkPrice } from '../../hooks/useEditNetworkPrice';
import { isLinePending, useNetworkPricesStore } from '../../NetworkPrices.store';
import { NetworkPriceLine } from '../../types';
import {
  calcNetworkAveragePrice,
  calcNetworkPriceVariation,
  calcNetworkRetailAveragePrice,
  getLineCellIds,
  getLineKey,
  getNetworkCellSkin,
  getNetworkPriceStatus,
} from '../../utils';
import { NetworkPriceInputCell } from '../NetworkPriceInputCell';
import styles from './AveragePriceCell.module.scss';

type AveragePriceCellProps = { line: NetworkPriceLine };

const NETWORK_COLUMN = 'network';

export const AveragePriceCell = ({ line }: AveragePriceCellProps) => {
  const lineKey = getLineKey(line);
  const cellIds = getLineCellIds(line);
  // undefined = no draft; null = the user cleared the field.
  const draft = useNetworkPricesStore(state => state.networkDraftPrices[lineKey]);
  const averagePrice = useNetworkPricesStore(state => calcNetworkAveragePrice(line, state.draftPrices));
  const isPending = useNetworkPricesStore(state => isLinePending(state, lineKey, cellIds));
  const setNetworkDraftPrice = useNetworkPricesStore(state => state.setNetworkDraftPrice);
  const { commitNetworkPrice } = useEditNetworkPrice();
  const priceStatus = getNetworkPriceStatus(line);
  const displayedPrice = draft === undefined ? averagePrice : draft;

  if (cellIds.length === 0) return <span className={styles.unavailable}>--</span>;

  return (
    <NetworkPriceInputCell
      ariaLabel={`Preço médio de ${line.description} na rede`}
      column={NETWORK_COLUMN}
      value={displayedPrice}
      skin={getNetworkCellSkin(priceStatus, draft !== undefined)}
      variation={calcNetworkPriceVariation(displayedPrice, calcNetworkRetailAveragePrice(line))}
      priceStatus={priceStatus}
      isPending={isPending}
      onChange={value => setNetworkDraftPrice(lineKey, value)}
      onCommit={() => commitNetworkPrice(line)}
    />
  );
};
